import styled from '@emotion/styled';
import { usePathname } from 'next/navigation';
import { getLinkPropsForUrl } from '../../../navigation/getLinkPropsForUrl';
import { RouterLink } from '../link/RouterLink';
import { Css, ITheme, IUrlLinkItem } from '../../../ui';
import { getCurrentAirportCodeFromSlug } from '../navigation/utils/getCurrentAirportCode';
import { AirportCodes } from '../../../types/airports';
import { Color } from '../../../styles/Color';

export interface IFooterLinkListProps {
	links: IUrlLinkItem[];
}

export function FooterLinkList({ links }: IFooterLinkListProps) {
	const pathname = usePathname();
	const airportCode = getCurrentAirportCodeFromSlug(pathname);

	return (
		<StyledFooterLinkList
			withThemeColor={airportCode !== AirportCodes.Corporate}
		>
			{links.map((link) => (
				<li key={link.key ? link.key : link.title} className="no-max-width">
					<RouterLink {...getLinkPropsForUrl(link.url)}>
						{link.title}
					</RouterLink>
				</li>
			))}
		</StyledFooterLinkList>
	);
}

export const StyledFooterLinkList = styled.ul<
	{ withThemeColor: boolean },
	ITheme
>`
	list-style: none;
	padding: 0;
	margin: 0;

	li {
		margin-bottom: ${Css.pxToRem(16)};
		padding-left: 0;
		line-height: normal;

		&:last-of-type {
			margin-bottom: 0;
		}

		a {
			color: ${(props) =>
				props.withThemeColor
					? props.theme.color.onPrimary
					: Color.OnBackground};
			text-decoration: none;
			font-weight: 300;

			&:hover {
				text-decoration: underline;
				color: ${(props) => props.theme.color.secondaryLight};
			}
		}
	}
`;
